import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { performLogout } from '../utils/authUtils';

/**
 * AutoLogoutListener - Listens for autoLogout event and performs logout
 * Should be mounted inside Router to have access to useNavigate
 */
const AutoLogoutListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAutoLogout = async () => {
      console.log('[AutoLogoutListener] Auto-logout event received, logging out user');
      await performLogout(navigate);
    };

    window.addEventListener('autoLogout', handleAutoLogout);

    return () => {
      window.removeEventListener('autoLogout', handleAutoLogout);
    };
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default AutoLogoutListener;
